import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender, statusRenderReceipt } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";
import { fetchTotalSalesDetail } from "../actions/user";

const TotalSalesDetail = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { totalSalesDetail } = useSelector((state) => state.userReducer);
  //breadcrumb
  const translateModule = "salesDetail";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchTotalSalesDetail());
  }, [dispatch]);

  const months = {
    1: "Januar",
    2: "Februar",
    3: "Mart",
    4: "April",
    5: "Maj",
    6: "Jun",
    7: "Jul",
    8: "Avgust",
    9: "Septembar",
    10: "Oktobar",
    11: "Novembar",
    12: "Decembar",
  };
  const columnDefs = [
    {
      headerName: "Kurs",
      field: "name",
      filter: "agSetColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: "Godina",
      field: "year",
      width: 120,
      filter: "agSetColumnFilter",
    },
    {
      headerName: "Mesec",
      field: "month",
      filter: "agSetColumnFilter",
      maxWidth: 140,
      valueGetter: (params) => months[params.data?.month] || "",
      filterValueGetter: (params) => months[params.data?.month] || "",
    },
    {
      headerName: "Cena",
      field: "price",
      filter: "agNumberColumnFilter",
      maxWidth: 140,
    },
    {
      headerName: "Ukupna zarada",
      field: "revenue",
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Ukupna prodaja",
      field: "sales",
      filter: "agNumberColumnFilter",
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchTotalSalesDetail()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={totalSalesDetail}
        columnDefs={columnDefs}
        //  buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="total-sales-detail-list"
      />
    </Fragment>
  );
};

export default TotalSalesDetail;
